import { getBottomPadding, getTopPadding } from '../../../utils/sessionStorage'
import { SecondaryButton } from '../../../components/execution/SecondaryButton'
import RenderHTML from '../../../components/ui-components/RenderHTML'

type MFCRedirectionErrorPageProps = {
  statusCode: string
  message?: string
  onTryAgain: () => void
  onGoToPortfolio: () => void
}

export function MFCRedirectionErrorPage({
  statusCode,
  message = 'Please try again.',
  onTryAgain,
  onGoToPortfolio
}: MFCRedirectionErrorPageProps) {
  return (
    <div className='h-screen overflow-y-scroll no-scrollbar bg-white flex flex-col'>
      <div style={{ paddingTop: `${getTopPadding() + 12}px`, paddingBottom: `${getBottomPadding()}px` }} className='flex-1 flex flex-col justify-center px-5'>
        <RenderHTML innerHTMLText={WarningIcon} />
        <h1 className='text-[28px] font-[500] text-[#232323] pb-2 pt-2'>Something went wrong</h1>
        <p className='text-[14px] text-[#6A6E6E] font-[400] text-left'>
          {message}
          {/* <span className='text-[#6A6E6E] text-[6px]'>({statusCode})</span> */}
        </p>
      </div>
      <div style={{ paddingBottom: `${getBottomPadding() + 8}px` }} className='px-4 pt-4 flex flex-col gap-3'>
        {/* <PrimaryButton label='Try again' onClick={onTryAgain} primaryButtonClassName='!h-[56px] !text-[16px] !font-[500]' /> */}
        <SecondaryButton label='Go to portfolio' onClick={onGoToPortfolio} secondaryButtonClassName='!h-[56px] !text-[16px] !font-[500]' />
      </div>
    </div>
  )
}

export const WarningIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
  <path d="M29.0525 40.0725C28.4586 40.6662 27.6532 41 26.8133 41H15.1867C14.3468 41 13.5414 40.6662 12.9475 40.0725L2.92749 30.0525C2.33364 29.4586 2 28.6532 2 27.8133V16.1867C2 15.3468 2.33364 14.5414 2.92749 13.9475L12.9475 3.92749C13.5414 3.33364 14.3468 3 15.1867 3H26.8133C27.6532 3 28.4586 3.33364 29.0525 3.92749L39.0725 13.9475C39.6662 14.5414 40 15.3468 40 16.1867V27.8133C40 28.6532 39.6662 29.4586 39.0725 30.0525L29.0525 40.0725Z" stroke="#D9892B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 13.0469V23.7504" stroke="#D9892B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21.0003 30.9616C20.5881 30.9616 20.2539 30.6274 20.2539 30.2152C20.2539 29.8029 20.5881 29.4688 21.0003 29.4688" stroke="#D9892B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M21 30.9616C21.4122 30.9616 21.7464 30.6274 21.7464 30.2152C21.7464 29.8029 21.4122 29.4688 21 29.4688" stroke="#D9892B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
